import React, { useState } from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Typography,
    Form,
    Button,
    DatePicker,
    message,
    AutoComplete
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import axios from '../../config/axios';
import rawProvince from '../../utils/province.json';

export default function Create() {

    const [result, setResult] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    
    const redirect = useNavigate();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/warehouse/', data)
                .then( res => {
                    // console.log("create customer :",res);
                    messageApi.open({
                        type: 'success',
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => redirect(`/admin/warehouses`)
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });


    // const onFinish = (values) => console.log(values);
    const onFinish = (values) => mutate(values);

    const handleDistrictSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.district.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleAmphoeSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.amphoe.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleProvinceSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.province.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const onSelect = info => {
        const splitTambon = info.split('/');
        form.setFieldsValue({
            sub_district: splitTambon[0],
            district: splitTambon[1],
            province: splitTambon[2],
            postalcode: splitTambon[3]
        })
    };

    // console.log("rawProvince: ", rawProvince);
    return (
        <div style={{
            background: '#fff',
        }}>
            {contextHolder}
            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    <Typography.Title level={3}>
                        เพิ่มคลังสินค้า
                    </Typography.Title>
                </Col>
                <Divider />
                <Col xs={24}>
                    <Form
                        name="createEmployee"
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                    // initialValues={{
                    //     'input-number': 3,
                    //     'checkbox-group': ['A', 'B'],
                    //     rate: 3.5,
                    //     'color-picker': null,
                    // }}
                    // style={{
                    //     maxWidth: 600,
                    // }}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ชื่อ"
                                            name="company"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ชื่อผู้ติดต่อ"
                                            name="fname"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="เบอร์โทรศัพท์"
                                            name="phone"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="อีเมล์"
                                            name="email"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="หมายเลขประจำตัวผู้เสียภาษี/หมายเลขบัตรประชาชน"
                                            name="idcard"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="วัน เดือน ปี เกิด"
                                            name="birth_date"
                                        >
                                            <DatePicker style={{ width: "100%" }} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item name="address" label="ที่อยู่">
                                            <Input.TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ตำบล"
                                            name="sub_district"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleDistrictSearch}
                                            >
                                                {result.map((tam) => (
                                                    <AutoComplete.Option key={tam} value={tam}>
                                                        {tam}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="อำเภอ"
                                            name="district"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleAmphoeSearch}
                                            >
                                                {result.map((amp) => (
                                                    <AutoComplete.Option key={amp} value={amp}>
                                                        {amp}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="จังหวัด"
                                            name="province"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleProvinceSearch}
                                            >
                                                {result.map((prov) => (
                                                    <AutoComplete.Option key={prov} value={prov}>
                                                        {prov}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="รหัสไปรษณีย์"
                                            name="postalcode"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'กรุณากรอกข้อมูล!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} >
                                        <Row justify="end">
                                            <Col>
                                                <Form.Item>
                                                    <Button type="primary" htmlType="submit" disabled={isLoading}>
                                                        บันทึก
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}
